export const addThumbsClicks = (emblaApiMain, emblaApiThumb) => {
  const slidesThumbs = emblaApiThumb.slideNodes();

  const scrollToIndex = slidesThumbs.map(
    (_, index) => () => emblaApiMain.scrollTo(index),
  );

  slidesThumbs.forEach((slideNode, index) => {
    slideNode.addEventListener('click', scrollToIndex[index], false);
  });
};

export const addToggleThumbActive = (emblaApiMain, emblaApiThumb) => {
  const slidesThumbs = emblaApiThumb.slideNodes();

  const toggleThumbState = () => {
    emblaApiThumb.scrollTo(emblaApiMain.selectedScrollSnap());
    const previous = emblaApiMain.previousScrollSnap();
    const selected = emblaApiMain.selectedScrollSnap();
    slidesThumbs[previous].classList.remove('embla-thumbs__slide--selected');
    slidesThumbs[selected].classList.add('embla-thumbs__slide--selected');
  };

  emblaApiMain.on('select', toggleThumbState);
  emblaApiMain.on('reInit', toggleThumbState);
  emblaApiThumb.on('init', toggleThumbState);
};

export const initEmblaDots = (emblaApi, dotsNode) => {
  const handleDots = () => {
    dotsNode.innerHTML = emblaApi
      .scrollSnapList()
      .map(() => '<button class="embla__dot" type="button"></button>')
      .join('');

    dotsNode.addEventListener('click', ({ currentTarget, target }) => {
      const index = [...currentTarget.children].indexOf(target);
      if (index >= 0 && target.classList.contains('embla__dot')) {
        emblaApi.scrollTo(index);
      }
    });
  };

  const toggleDotLinksActive = () => {
    const dotNodes = dotsNode.children;

    const previous = emblaApi.previousScrollSnap();
    const selected = emblaApi.selectedScrollSnap();
    dotNodes[previous].classList.remove('embla__dot--selected');
    dotNodes[selected].classList.add('embla__dot--selected');
  };

  emblaApi
    .on('init', handleDots)
    .on('reInit', handleDots)
    .on('init', toggleDotLinksActive)
    .on('reInit', toggleDotLinksActive)
    .on('select', toggleDotLinksActive);
};
